/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiCostBearer, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of CostBearersController.
 */
export class CostBearersRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /cost_bearers:prefill
     */
    public createPrefilled(): Promise<Result<ApiCostBearer>> {
        return this.http.post<Result<ApiCostBearer>, undefined>('/cost_bearers:prefill', undefined);
    }

    /**
     * Calls GET /cost_bearers:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiCostBearer>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiCostBearer>>>('/cost_bearers:query', query);
    }

    /**
     * Calls POST /cost_bearers:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiCostBearer>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCostBearer>>, ListRequest>('/cost_bearers:query', listRequest, query);
    }

    /**
     * Calls POST /cost_bearers/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiCostBearer>>> {
        return this.http.post<Result<LockedContextDto<ApiCostBearer>>, undefined>(`/cost_bearers/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /cost_bearers/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiCostBearer>> {
        return this.http.post<Result<ApiCostBearer>, undefined>(`/cost_bearers/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /cost_bearers/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiCostBearer[]>> {
        return this.http.post<Result<ApiCostBearer[]>, string[]>('/cost_bearers/locks', ids);
    }

    /**
     * Calls POST /cost_bearers/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/cost_bearers/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /cost_bearers/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/cost_bearers/${primaryId}/locks`);
    }

    /**
     * Calls GET /cost_bearers/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiCostBearer>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiCostBearer>>(`/cost_bearers/${primaryId}`, query);
    }

    /**
     * Calls POST /cost_bearers
     */
    public add(dto: ApiCostBearer): Promise<Result<ApiCostBearer>> {
        return this.http.post<Result<ApiCostBearer>, ApiCostBearer>('/cost_bearers', dto);
    }

    /**
     * Calls PUT /cost_bearers/{primaryId}
     */
    public update(dto: ApiCostBearer, primaryId: string): Promise<Result<ApiCostBearer>> {
        return this.http.put<Result<ApiCostBearer>, ApiCostBearer>(`/cost_bearers/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /cost_bearers
     */
    public putRange(dtos: ApiCostBearer[]): Promise<Result<ApiCostBearer[]>> {
        return this.http.patch<Result<ApiCostBearer[]>, ApiCostBearer[]>('/cost_bearers', dtos);
    }

    /**
     * Calls DELETE /cost_bearers/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/cost_bearers/${primaryId}`);
    }

    /**
     * Calls POST /costbearers:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiCostBearer>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiCostBearer>>, ListRequestWithIds>('/costbearers:batch', listRequest, query);
    }
}
